import { render } from "./changeRegionModal.vue?vue&type=template&id=11929639&ts=true"
import script from "./changeRegionModal.vue?vue&type=script&lang=ts"
export * from "./changeRegionModal.vue?vue&type=script&lang=ts"

import "./changeRegionModal.vue?vue&type=style&index=0&id=11929639&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__